import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary

function EmergencyNumber() {

    const documents = [
      {
        title: "CAS-701-01-02 ",
        modified: "July 19, 2019",
        items: [
          "Casualty-Accident Report (TV5-325)",
        ],
      },
      {
        title: "CAS-701-01-03 ",
        modified: "July 19, 2019",
        items: [
          "Casualty-Accident Report incl. Occupational Report",
        //   "INS-701-09-01 Towage Inspection",
        ],
      },
      {
        title: "CAS-701-01-04 ",
        modified: "July 19, 2019",
        items: [
          "Occupational Casualty Reporting Form (Shore Labour)",
        //   "INNotification_of_intention_to_build_0.",
        ],
      },
      {
        title: "CAS-701-01-05 ",
        modified: "July 19, 2019",
        items: [
          "Small Vessel Marine Incident Report Form",
        //   "INNotification_of_intention_to_build_0.",
        ],
      },
    ];

  return (
    <>
      <div className="service-title text-green-38B652 font-700 mb-3 text-uppercase">
        EMERGENCY NUMBER
      </div>
      <div className="service-box mb-5 mb-sm-4">
        For all urgent matters and emergencies, please contact us immediately
        using the numbers listed below. Identify the correct contact for your
        situation for a swift and direct response.
      </div>

      <div className="row g-3 g-sm-4">
        <div className="col-lg-5 col-md-6 col-sm-6">
          <p className="font-17 text-primary-color">
            <b>​​Inland Region (Boating)</b>
          </p>
          <p className="font-17 text-primary-color">
            MRCC (Gauteng, Free State, Mpumalanga, Limpopo and North West)
          </p>
          <p className="font-17 text-primary-color">
            <span className="font-600">Contact Number:</span> 021-938-3300
          </p>
        </div>

        <div className="col-lg-5 col-md-6 col-sm-6">
          <p className="font-17 text-primary-color">
            <b>Western Region</b>
          </p>
          <p className="font-17 text-primary-color">
            (Port Nolloth, Saldanha Bay and Cape Town){" "}
          </p>
          <p className="font-17 text-primary-color">
            <span className="font-600">Contact Number:</span> 072-364-4958
          </p>
        </div>

        <div className="col-lg-5 col-md-6 col-sm-6">
          <p className="font-17 text-primary-color">
            <b>​Southern Region</b>
          </p>
          <p className="font-17 text-primary-color">
            (Mossel Bay; Port Elizabeth and East London)
          </p>
          <p className="font-17 text-primary-color">
            <span className="font-600">Contact Number:</span> 076-859-6790
          </p>
        </div>

        <div className="col-lg-5 col-md-6 col-sm-6">
          <p className="font-17 text-primary-color">
            <b>Eastern Region</b>
          </p>
          <p className="font-17 text-primary-color">(Durban & Richards Bay) </p>
          <p className="font-17 text-primary-color">
            <span className="font-600">Contact Number:</span> 066 282 4304​
          </p>
        </div>

        {/* <div className="col-12 ">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  Casualty Report Forms
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <ul className="strip-ul">
                    {documents.map((doc, index) => (
                      <li key={index}>
                        <div className="row g-4">
                          <div className="col-auto">
                            <img src={pdfIcon} alt="PDF icon" />
                          </div>
                          <div className="col">
                            <div className="row g-4">
                              <div className="col-md">
                                <div className="font-18 font-600">
                                  File Name
                                </div>
                                <div className="font-16 font-400">
                                  <p className="text-orange-ef3e33 text-uppercase">
                                    {doc.title}
                                  </p>
                                  
                                    {doc.items.map((item, i) => (
                                      <p key={i}><a href="#">{item}</a></p>
                                    ))}
                                  
                                </div>
                              </div>
                              <div className="col-md-auto">
                                <div className="font-18 font-600">Modified</div>
                                <div className="font-16 font-400">
                                  {doc.modified}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default EmergencyNumber;